import React from "react";
import "../styles/main.css";
import Navbar from "../components/Navbar";
import mobileinhand from "../assets/mobileinhand.png";
import Ellipse from "../assets/Ellipse57.svg";
import "react-lazy-load-image-component/src/effects/opacity.css";

const VFF_mainPage = () => {
  return (
  <div className="flex flex-col min-h-screen overflow-hidden">

      

      <div className=" sm:relative  flex-1 overflow-hidden bg-gradient-radial-30 bg-opacity-30 flex flex-col bg-no-repeat bg-center bg-cover transition-all duration-700">
<Navbar />
        {/* Top Right Blob */}
        <div className="absolute top-[-10%] right-[0%] w-[700px] h-[700px] rounded-full opacity-40 blur-3xl pointer-events-none">
          <div
            className="absolute inset-0 rounded-full"
            style={{
              background:
                "radial-gradient(circle, rgba(255, 206, 0, 0.5) 10%, rgba(0, 160, 255, 0) 70%)",
            }}
          ></div>

          <img
            src={Ellipse}
            alt="Ellipse"
            className="absolute inset-0 w-full h-full object-contain"
          />
        </div>

        {/* Bottom Left Blob */}
        <div className="absolute bottom-[-15%] left-[-10%] w-[700px] h-[700px] rounded-full opacity-40 blur-3xl pointer-events-none">
          <div
            className="absolute inset-0 rounded-full"
            style={{
              background:
                "radial-gradient(circle, rgba(255, 206, 0, 0.5) 10%, rgba(0, 160, 255, 0) 70%)",
            }}
          ></div>

          <img
            src={Ellipse}
            alt="Ellipse"
            className="absolute inset-0 w-full h-full object-contain"
          />
        </div>

        {/* Content */}
        <div className="flex flex-col items-center justify-start flex-1 px-4 relative z-10 text-center pt-[72px]">

          <h1
            style={{ fontFamily: "Norwester" }}
            className="text-[68px] xl:text-[60px] lg:text-[58px] md:text-[52px] sm:text-4xl  text-[#FFF528] mb-4"
          >
            VUPOP FOR FANS
          </h1>

          <p className="font-Inter text-[32px] xl:text-[28px] lg:text-[24px] sm:text-2xl font-[600] text-white mb-5 max-w-3xl sm:mt-4 sm:px-4 test-paragraph">
            Your View. Your Voice. Your Moment.
          </p>

         <p className="font-Inter font-[400] max-w-5xl xl:max-w-3xl lg:max-w-2xl md:max-w-xl sm:max-w-full text-[18px] xl:text-[18px] lg:text-[16px] md:text-[15px] sm:text-[14px] text-[#ADADAD] mb-10 px-6 leading-relaxed">
            Sport is nothing without fans. The songs, the noise and the reactions
            give life to every match. With Vupop, you can capture and share your
            fan content and become part of how sports are seen and remembered.
          </p>

          {/* Buttons */}
          <div className="flex flex-wrap mb-6 justify-center gap-4">

             {/* Google Play */}
             <a
              href="https://play.google.com/store/apps/details?id=com.app.vupop&pcampaignid=web_share"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#1a1a1a] hover:bg-[#2a2a2a] transition-colors px-6 py-3 rounded-xl flex items-center gap-3 min-w-[200px]"
            >
              <svg className="w-8 h-8" viewBox="0 0 24 24" fill="none">
                <path d="M3 20.5V3.5C3 2.91 3.34 2.39 3.84 2.15L13.69 12L3.84 21.85C3.34 21.6 3 21.09 3 20.5Z" fill="#00A0FF"/>
                <path d="M16.81 15.12L6.05 21.34L14.54 12.85L16.81 15.12Z" fill="#FF3E4C"/>
                <path d="M3.84 2.15C4.25 1.93 4.73 1.94 5.13 2.15L16.81 8.88L14.54 11.15L3.84 2.15Z" fill="#00D856"/>
                <path d="M16.81 8.88L20.16 10.75C21.23 11.35 21.23 12.64 20.16 13.25L16.81 15.12L14.54 12.85L16.81 8.88Z" fill="#FFCE00"/>
              </svg>

              <div className="text-left">
                <div className="text-xs text-white">GET IT ON</div>
                <div className="text-lg font-semibold text-white">Google Play</div>
              </div>
            </a>

            {/* App Store */}
            <a
              href="https://apps.apple.com/app/vupop/id6747295116"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#1a1a1a] hover:bg-[#2a2a2a] transition-colors px-6 py-3 rounded-xl flex items-center gap-3 min-w-[200px]"
            >
              <svg className="w-8 h-8" viewBox="0 0 24 24" fill="white">
                <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
              </svg>

              <div className="text-left">
                <div className="text-xs text-white">Download on the</div>
                <div className="text-lg font-semibold text-white">App Store</div>
              </div>
            </a>

          </div>

          {/* Image */}
          <img
            src={mobileinhand}
            alt="Mobile in Hand"
            className="w-[550px] max-w-full"
          />

        </div>
      </div>
    </div>
  );
};

export default VFF_mainPage;
